// extracted by mini-css-extract-plugin
export var statItem = "_gd-1";
export var statsRow = "_gd-0";